"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoneVsZoneValidationResult = void 0;
/**
 * The result of a ZoneVsZoneRule validation containing information about which function zones collided and which
 * entities they belong to.
 */
var ZoneVsZoneValidationResult = /** @class */ (function () {
    function ZoneVsZoneValidationResult(resultType, failedRule, entityWithZone1, intersectingZone1, entityWithZone2, intersectingZone2) {
        this.resultType = resultType;
        this.failedRule = failedRule;
        this.entityWithZone1 = entityWithZone1;
        this.intersectingZone1 = intersectingZone1;
        this.entityWithZone2 = entityWithZone2;
        this.intersectingZone2 = intersectingZone2;
        this.id = 'ZoneVsZoneValidationResult';
    }
    return ZoneVsZoneValidationResult;
}());
exports.ZoneVsZoneValidationResult = ZoneVsZoneValidationResult;
//# sourceMappingURL=ZoneVsZoneValidationResult.js.map